common.View.create('crud::form.Index', {

    onDOMLoad() {
        setTimeout(() => {
            this.initFocusFirstInput();
            this.manageTabErrors();
        }, 1);
    },

    initFocusFirstInput()
    {
        // Find first active element
        if (this.element.data('focus') && $(window).width() >= 1280) {
            // Get current scroll
            let x = window.scrollX, y = window.scrollY;

            // Focus first input
            this.element.find('*:input,select,textarea')
                .filter(':not([type=radio]):not([type=checkbox])')
                .filter('[type!=hidden]:not([readonly]):not([disabled])')
                .first()
                .focus();

            // Scroll back to user current scroll
            window.scrollTo(x, y);
        }
    },

    manageTabErrors() {
        // Abort due to no tabs present?
        if(!this.element.find('.nav-tabs').length) {
            return;
        }

        this.element.find('.nav-tabs a:not(".hidden")')
            .each(this.manageTabItemErrors.bind(this))
            .end();
    },

    manageTabItemErrors(index, tabItemElement) {
        // Get related tab panel.
        let tabContent = this.element.find('#'+$(tabItemElement).data('target')).first();

        // Determine if has errors.
        let hasInputWithErrors = tabContent.find('.has-error').length > 0;

        // Show/hide errors on tab.
        $(tabItemElement).toggleClass('has-error', hasInputWithErrors);

        // Determine if required fields are not filled in
        tabContent.find('input:required')
            .on('invalid', (event) => {
                // If required field doesn't have a value
                $(event.currentTarget).parents('.form-group').addClass('has-error');

                // Show/hide errors on tab.
                $(tabItemElement).addClass('has-error');
            });
    }
});
